import { useEffect, useState } from "react";

export interface UserPosition {
  lat: number;
  lng: number;
  accuracy?: number;
}

export function useUserPosition(): UserPosition | null {
  const [pos, setPos] = useState<UserPosition | null>(null);

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.geolocation) return;

    const watchId = navigator.geolocation.watchPosition(
      (p) => {
        setPos({
          lat: p.coords.latitude,
          lng: p.coords.longitude,
          accuracy: p.coords.accuracy,
        });
      },
      () => {
        setPos(null);
      },
      { enableHighAccuracy: true, maximumAge: 5_000, timeout: 15_000 },
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  return pos;
}
